import "roboto-fontface/css/roboto/roboto-fontface.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "./cwx-vuetify-styles.scss";

import Vue from "vue";
import Vuetify from "vuetify";
import { i18n } from "./translations";
export { i18n } from "./translations";

console.log("from vuetify.ts");

Vue.use(Vuetify, {
  iconfont: "md",
  icons: {
    // Changing the default icon used for close chips
    delete: "close"
  },
  theme: false, //disable theming because it inject at run-time global style tag (vuetify-theme-stylesheet) that interfere with CWX styles
  lang: {
    //Here we integrate "vue-i18" library with Vuetify internationalization support. "vue-i18" library is integrated with our current translations
    //solution from website project. Because of this we need to have keys in our "crowdworxtranslations" project that are internally used by Vuetify
    //components. All of those keys start with "NewListView" prefix. You can generate these keys with "./tools/generateVuetifyTranslationPoFiles.mjs" script.
    t: (key, ...params) => i18n.t(key, params)
  }
});
